import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsCardSchema = withDefaults({
  type: 'pcs-card',
  objectExtensions: ['pcs-card'],
  fields: [
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'program',
    },
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'amounts',
    },
    {
      kind: 'belongsTo',
      name: 'pcsCardHolder',
      type: 'pcs-card-holder',
      options: {
        async: false,
        inverse: 'pcsCards',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasApplication',
      type: 'tas-application',
      options: {
        async: false,
        inverse: 'pcsCards',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsCompany',
      type: 'pcs-company',
      options: {
        async: false,
        inverse: 'pcsCards',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsProvider',
      type: 'pcs-provider',
      options: {
        async: false,
        inverse: 'pcsCards',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsProgram',
      type: 'pcs-program',
      options: {
        async: false,
        inverse: 'pcsCards',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsAuthorizations',
      type: 'pcs-authorization',
      options: {
        async: false,
        inverse: 'pcsCard',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCardEvents',
      type: 'pcs-card-event',
      options: {
        async: false,
        inverse: 'pcsCard',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsDisputes',
      type: 'pcs-dispute',
      options: {
        async: false,
        inverse: 'pcsCard',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsTransactions',
      type: 'pcs-transaction',
      options: {
        async: false,
        inverse: 'pcsCard',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsMerchantWhitelist',
      type: 'pcs-merchant',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PcsCardSchema;
